import 'svgxuse'
import React from 'react'
import {render} from 'react-dom'
import App from 'components/app'

render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// src/client.js